<msd-subscription-banner (close)="closeBanner()"
                         *ngIf="bannerType !== undefined"
                         @trialBanner
                         [class]="bannerClass"
                         [remainingDays]="remainingDays"
                         [type]="bannerType">
</msd-subscription-banner>

<msd-e-invoicing-banner (close)="closeEInvoicingBanner()"
                        *ngIf="bannerEInvoicingType !== undefined"
                        @trialBanner
                        [class]="bannerEInvoicingClass"
                        [type]="bannerEInvoicingType"
                        [link]="['/dashboard', 'account', 'billParams']"
                        [tab]="'e-invoicing'">
</msd-e-invoicing-banner>
<router-outlet></router-outlet>
<msd-help-me [dietitian]="dietitian"></msd-help-me>

